import { Component, ElementRef, ViewChild, OnInit } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../../shared/services/bulk-maintenance/common.service';
import { ExportDataService } from '../../../../shared';
import { MaintenanceService } from '../../../../techopsv4/services/maintenanceService';
import { CapitaldemandBulkService } from '../../services/capitaldemand-bulk.service';
import { SharedAuthService } from '../../../../shared/shared.auth.service';
import { BULK_MAINTENANCE_ERROR_MESSAGES } from '../../shared/services/bulk-maintenance/bulk-maintenance-error-messages';
import { MatTabGroup, MatTab } from '@angular/material/tabs';
import { MaintenanceTableV4Component } from '../../maintenance-table-v4/maintenance-table-v4.component';
import { LoaderComponent } from '../../../../shared/elements/loader/loader.component';


@Component({
    selector: 'app-capitaldemand-bulk-edit',
    templateUrl: './capitaldemand-bulk-edit.component.html',
    styleUrl: './capitaldemand-bulk-edit.component.scss',
    imports: [MatTabGroup, MatTab, MaintenanceTableV4Component, LoaderComponent]
})
export class CapitaldemandBulkEditComponent implements OnInit {
  isDataLarge: boolean = false;
  showLoader: boolean = false;
  showtable: boolean = false;
  fileToUpload: File = null;
  showPreview: boolean = false;
  successPayload: any = [];
  failedData: any = [];
  uploadedData: any[];
  uploadedColumnNames: string[];
  missingColumns: string[] = [];
  @ViewChild('fileInput', { static: false }) fileInput: ElementRef;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  updateType: string = 'otleader';
  isFundingAdmin: boolean = false;

  TABLE_COLUMNS_FAIL: any[];

  TABLE_COLUMNS_PASS: any = [
    {
      key: 'Update Type',
      labelKey: "Update Type",
      label: 'Update Type',
      addNew: false,
      filter: false,
      search: '',
      searchValue: '',
      edit: true,
      required: true,
      validations: [{ 'required': false }],
      expand: false,
      // unique: true,
    },
    {
      key: 'Funding Segment',
      labelKey: "Funding Segment",
      label: 'Funding SegmentID',
      addNew: false,
      filter: false,
      search: '',
      searchValue: '',
      edit: true,
      validations: [{ 'required': false }],
      required: true,
      align: 'center !important',
      expand: false
    },
    {
      key: 'UCMG ID',
      labelKey: "UCMG ID",
      label: 'UCMG ID',
      addNew: false,
      filter: false,
      search: '',
      searchValue: '',
      edit: true,
      validations: [{ 'required': false }],
      required: true,
      align: 'center !important',
      expand: false,
      unique: true,
    },
    {
      key: 'Fiscal Year',
      labelKey: 'Fiscal Year',
      label: 'Fiscal Year',
      addNew: false,
      filter: false,
      search: '',
      searchValue: '',
      edit: true,
      validations: [{ 'required': false }],
      required: true,
      align: 'center !important',
      expand: false,
      unique: true,
    },
    {
      key: 'L1 MSID',
      labelKey: 'L1 MSID',
      label: 'L1 MSID',
      addNew: false,
      filter: false,
      search: '',
      searchValue: '',
      edit: true,
      validations: [{ 'required': false }],
      required: true,
      align: 'center !important',
      expand: false,
      unique: true,
    },
    {
      key: 'L2 MSID',
      labelKey: 'L2 MSID',
      label: 'L2 MSID',
      addNew: false,
      filter: false,
      search: '',
      searchValue: '',
      edit: true,
      validations: [{ 'required': false }],
      required: true,
      align: 'center !important',
      expand: false,
      unique: true,
    },
    {
      key: 'L3 MSID',
      labelKey: 'L3 MSID',
      label: 'L3 MSID',
      addNew: false,
      filter: false,
      search: '',
      searchValue: '',
      edit: true,
      validations: [{ 'required': false }],
      required: true,
      align: 'center !important',
      expand: false,
      unique: true,
    },
    {
      key: "OT Labor",
      labelKey: "OT Labor",
      label: 'OT Labor',
      addNew: false,
      filter: false,
      search: '',
      searchValue: '',
      edit: true,
      validations: [{ 'required': false }],
      required: true,
      align: 'center !important',
      expand: false
    }

  ];

  TABLE_COLUMNS_FAIL_UCMG: any[];
  TABLE_COLUMNS_PASS_UCMG: any = [
    {
      key: 'Update Type',
      labelKey: "Update Type",
      label: 'Update Type',
      addNew: false,
      filter: false,
      search: '',
      searchValue: '',
      edit: true,
      required: true,
      validations: [{ 'required': false }],
      expand: false
    },
    {
      key: 'Funding SegmentID',
      labelKey: "Funding SegmentID",
      label: 'Funding SegmentID',
      addNew: false,
      filter: false,
      search: '',
      searchValue: '',
      edit: true,
      validations: [{ 'required': false }],
      required: true,
      align: 'center !important',
      expand: false,
      unique: true,
    },
    {
      key: 'UCMG ID',
      labelKey: "UCMG ID",
      label: 'UCMG ID',
      addNew: false,
      filter: false,
      search: '',
      searchValue: '',
      edit: true,
      validations: [{ 'required': false }],
      required: true,
      align: 'center !important',
      expand: false,
      unique: true,
    },
    {
      key: 'UCMG',
      labelKey: "UCMG",
      label: 'UCMG',
      addNew: false,
      filter: false,
      search: '',
      searchValue: '',
      edit: true,
      validations: [{ 'required': false }],
      required: true,
      align: 'center !important',
      expand: true
    },
    {
      key: 'Fiscal Year',
      labelKey: 'Fiscal Year',
      label: 'Fiscal Year',
      addNew: false,
      filter: false,
      search: '',
      searchValue: '',
      edit: true,
      validations: [{ 'required': false }],
      required: true,
      align: 'center !important',
      expand: false,
      unique: true,
    },
    {
      key: 'Total Forecast',
      labelKey: 'Total Forecast',
      label: 'Total Forecast',
      addNew: false,
      filter: false,
      search: '',
      searchValue: '',
      edit: true,
      validations: [{ 'required': false }],
      required: true,
      align: 'center !important',
      expand: false
    },
    
    {
      key: 'Investment Status',
      labelKey: 'Investment Status',
      label: 'Investment Status',
      addNew: false,
      filter: false,
      search: '',
      searchValue: '',
      edit: true,
      validations: [{ 'required': false }],
      required: true,
      align: 'center !important',
      expand: false
    },
    {
      key: 'Optum Tech Labor',
      labelKey: 'Optum Tech Labor',
      label: 'Optum Tech Labor',
      addNew: false,
      filter: false,
      search: '',
      searchValue: '',
      edit: true,
      validations: [{ 'required': false }],
      required: true,
      align: 'center !important',
      expand: true
    },
    {
      key: "Advisory Services",
      labelKey: "Advisory Services",
      label: 'Advisory Services',
      addNew: false,
      filter: false,
      search: '',
      searchValue: '',
      edit: true,
      validations: [{ 'required': false }],
      required: true,
      align: 'center !important',
      expand: true
    },
    {
      key: "Business Labor",
      labelKey: "Business Labor",
      label: 'Business Labor',
      addNew: false,
      filter: false,
      search: '',
      searchValue: '',
      edit: true,
      validations: [{ 'required': false }],
      required: true,
      align: 'center !important',
      expand: true
    },
    {
      key: "Hardware/Software",
      labelKey: "Hardware/Software",
      label: 'Hardware/Software',
      addNew: false,
      filter: false,
      search: '',
      searchValue: '',
      edit: true,
      validations: [{ 'required': false }],
      required: true,
      align: 'center !important',
      expand: true
    },
    {
      key: "Other Chargebacks",
      labelKey: "Other Chargebacks",
      label: 'Other Chargebacks',
      addNew: false,
      filter: false,
      search: '',
      searchValue: '',
      edit: true,
      validations: [{ 'required': false }],
      required: true,
      align: 'center !important',
      expand: true
    },
    {
      key: "Ucmg Owner",
      labelKey: "Ucmg Owner",
      label: 'Ucmg Owner',
      addNew: false,
      filter: false,
      search: '',
      searchValue: '',
      edit: true,
      validations: [{ 'required': false }],
      required: true,
      align: 'center !important',
      expand: true
    },
    {
      key: "Portfolio Manager",
      labelKey: "Portfolio Manager",
      label: 'Portfolio Manager',
      addNew: false,
      filter: false,
      search: '',
      searchValue: '',
      edit: true,
      validations: [{ 'required': false }],
      required: true,
      align: 'center !important',
      expand: true
    }

  ];

  dataSourceDetails_fail: MatTableDataSource<unknown>;
  dataSourceDetails_Pass: MatTableDataSource<unknown>;
  TABLE_CONFIG: any = {
    pageSize: 10,
    pageIndex: 0,
    totalItems: 0,
    selection: false,
    edit: false,
    serverSidePagination: false,
    deleteFeature: true,
    FILTER_OPTIONS:{
      Message: []
    }
  };
  DATA_SCHEMA = {
    org_name: 'text',
    isEdit: 'isEdit',
    Message: 'select'
  };
  sortConfig = {
    active: 'Full_Name',
    direction: 'asc'
  };
  passdata: any[] = [];
  faildata: any[] = [];
  submitPayload: any;
  currentForecast: any;
  Filepath: string = 'assets/Capital_Demand_Bulk_Edit_Template.xlsx';
  validTime: boolean = true;
  otLeaderData: any;
  requiredHeaders: any;
  uniqueHeaders: any;
  PASS_COLUMN: any = [];
  FAIL_COLUMN: any = [];
  selectedIndex: number = 0;
  filteredData: any[] = [];
  activeFilters: { [key: string]: any[] } = {}; 
  constructor(public toaster: ToastrService, public exportService: ExportDataService, public commonService: CommonService, public maintenanceService: MaintenanceService, public bulkService: CapitaldemandBulkService,public sharedAuthService: SharedAuthService) { }
  ngOnInit() {
    this.TABLE_COLUMNS_FAIL = [{
      key: 'Message',
      labelKey: "Message",
      label: 'Error',
      addNew: false,
      filter: true,
      search: '',
      searchValue: '',
      edit: true,
      validations: [{ 'required': false }]
    }, ...this.TABLE_COLUMNS_PASS];
    this.TABLE_COLUMNS_FAIL_UCMG = [{
      key: 'Message',
      labelKey: "Message",
      label: 'Error',
      addNew: false,
      filter: true,
      search: '',
      searchValue: '',
      edit: true,
      validations: [{ 'required': false }]
    }, ...this.TABLE_COLUMNS_PASS_UCMG];
    this.PASS_COLUMN = this.TABLE_COLUMNS_PASS;
    this.requiredHeaders = this.PASS_COLUMN.filter(item => item.required).map(item => item.label);
    this.uniqueHeaders = this.PASS_COLUMN.filter(item => item.unique).map(item => item.label);
    this.isFundingAdmin = this.sharedAuthService.getFundingAccessDetails('');
    this.getOtLeaderData();
  }

  getOtLeaderData() {
    this.showLoader = true;
    this.maintenanceService.getOtLeaderData().subscribe(
      data => {
        this.showLoader = false;
        this.otLeaderData = data;

      },
      error => {
        console.error(error);
        this.showLoader = false;
        this.toaster.error(
          BULK_MAINTENANCE_ERROR_MESSAGES.CAPITAL_DEMAND_BULK.GENERIC_ERROR,
          '',
          {
          positionClass: 'toast-top-center',
          timeOut: 1000
        });
      }
    );
  }

  uploadBulkTemplate(files: FileList) {
    if (files && files.length) {
      this.isDataLarge = false;
      this.showtable = !this.showtable;
      this.fileToUpload = files.item(0);
      this.commonService.convertCsvToArray(this.fileToUpload).then(data => {
        this.uploadedData = data.excelRows;
        this.uploadedColumnNames = data.headers;
      });
      this.successPayload = [];
      this.failedData = [];
      this.showtable = false;
      this.showPreview = true;

    } else {
      this.fileToUpload = null;
    }
  }

  downloadOtData() {
    const exportData = [];
    if (this.otLeaderData.length == 0) {
      return;
    }
    this.otLeaderData.forEach((element) => {
      const exportJSON: any = {};
      exportJSON['L1 Name'] = element['leader_level_1'] || '';
      exportJSON['L1 MSID'] = element['leader_level_1_msid'] || '';
      exportJSON['L2 Name'] = element['leader_level_2'] || '';
      exportJSON['L2 MSID'] = element['leader_level_2_msid'] || '';
      exportJSON['L3 Name'] = element['leader_level_3'] || '';
      exportJSON['L3 MSID'] = element['leader_level_3_msid'] || '';
      exportData.push(exportJSON);
    });
    this.exportService.exportToExcel('Ot Leader Data', [exportData])
  }

  onFilterApplied(event: { columnKey: string, selectedValues: any[] }) {
    if (Object.keys(this.activeFilters).length != 0) {
      this.activeFilters = {};
    }
    this.activeFilters[event.columnKey] = event.selectedValues;
    this.applyFilters();
  }

  onFilterCleared(columnKey: string) {
    delete this.activeFilters[columnKey];
    this.applyFilters();
  }

 
  applyFilters() {
    const filtered = this.faildata.filter(row => {
      return Object.keys(this.activeFilters).every(columnKey => {
        if (!this.activeFilters[columnKey] || this.activeFilters[columnKey].length === 0) {
          return true; 
        }         
        if (columnKey === 'Message' && row[columnKey]) {
          const rowMessages = row[columnKey]?.split(',').map(message => message.trim()) || [];
          return this.activeFilters[columnKey].some(filter => rowMessages.includes(filter));
        }           
        return this.activeFilters[columnKey].includes(row[columnKey]);
      });
    });       
    this.dataSourceDetails_fail = new MatTableDataSource(filtered);
  }

  submitForm() {
    if (this.faildata.length > 0) {
      this.exportAppData();
    }
    this.showtable = false;
    this.showPreview = false;
    const payload = {
      User_msid: this.sharedAuthService.getMsid(),
      User_email: sessionStorage.getItem('loggedInUserEmail'),
      Action_Type: 'Capital_Demand_Edit',
    };
    this.submitPayload = {
      excelValidatedRecords: this.passdata,
      payload: payload,
    };
    if (this.updateType == 'otleader') {
      this.maintenanceService.capitalDemandBulkSubmit(this.submitPayload).subscribe(
        data => {
          this.fileToUpload = null;
          this.fileInput?.nativeElement ? this.fileInput.nativeElement.value = '' : '';
          this.showtable = false;
          this.showLoader = false;

          if (data['error'] == undefined) {
            this.toaster.success(
              BULK_MAINTENANCE_ERROR_MESSAGES.CAPITAL_DEMAND_BULK.SUBMIT_SUCCESS,
              '',
              { positionClass: 'toast-top-center', timeOut: 2000 }
            );
          }
          if (data['error']) {
            this.showLoader = false;
            this.toaster.error(data['error'], '', { positionClass: 'toast-top-center', timeOut: 2000 });
          }
        },
        error => {
          console.error(error);
          this.showLoader = false;
          this.toaster.error(
            BULK_MAINTENANCE_ERROR_MESSAGES.CAPITAL_DEMAND_BULK.GENERIC_ERROR,
            '',
            {
            positionClass: 'toast-top-center',
            timeOut: 1000
          });
        }
      );
    } else {
      this.maintenanceService.capitalDemandUCMGBulkSubmit(this.submitPayload).subscribe(
        data => {
          this.fileToUpload = null;
         this.fileInput?.nativeElement ? this.fileInput.nativeElement.value = '' : '';
          this.showtable = false;
          this.showLoader = false;

          if (data['error'] == undefined) {
            this.toaster.success(
              BULK_MAINTENANCE_ERROR_MESSAGES.CAPITAL_DEMAND_BULK.SUBMIT_SUCCESS,
              '',
              { positionClass: 'toast-top-center', timeOut: 2000 }
            );
          }
          if (data['error']) {
            this.showLoader = false;
            this.toaster.error(data['error'], '', { positionClass: 'toast-top-center', timeOut: 2000 });
          }
        },
        error => {
          console.error(error);
          this.showLoader = false;
          this.toaster.error(
            BULK_MAINTENANCE_ERROR_MESSAGES.CAPITAL_DEMAND_BULK.GENERIC_ERROR,
            '',
            {
            positionClass: 'toast-top-center',
            timeOut: 1000
          });
        }
      );
    }
  }

  cancelUpload() {
    this.fileToUpload = null;
   this.fileInput?.nativeElement ? this.fileInput.nativeElement.value = '' : '';
    this.showtable = false;
    this.showPreview = false;
    this.missingColumns = [];
    this.isDataLarge = false;
  }

  tabChange(event: any) {
    this.showtable = false;
    this.showPreview = false;
    this.fileToUpload = null;
    this.fileInput?.nativeElement ? this.fileInput.nativeElement.value = '' : '';
    this.uploadedData = [];
    this.uploadedColumnNames = [];
    this.missingColumns = [];
    this.isDataLarge = false;
    if (event.index === 0) {
      this.updateType = 'otleader';
      this.PASS_COLUMN = this.TABLE_COLUMNS_PASS;
      this.FAIL_COLUMN = this.TABLE_COLUMNS_FAIL;
      this.Filepath = 'assets/Capital_Demand_Bulk_Edit_Template.xlsx';
    } else if (event.index === 1) {
      this.updateType = 'ucmg';
      this.PASS_COLUMN = this.TABLE_COLUMNS_PASS_UCMG;
      this.FAIL_COLUMN = this.TABLE_COLUMNS_FAIL_UCMG;
      this.Filepath = 'assets/Capital_Demand_UCMG_Bulk_Edit_Template.xlsx';
    }
    this.requiredHeaders = this.PASS_COLUMN.filter(item => item.required).map(item => item.label);
    this.uniqueHeaders = this.PASS_COLUMN.filter(item => item.unique).map(item => item.label);
  }

  previewData() {
    // Validate file format
    if (!this.commonService.validateFileFormat(this.fileToUpload)) {
      this.toaster.error(BULK_MAINTENANCE_ERROR_MESSAGES.CAPITAL_DEMAND_BULK.FILE_FORMAT_UNSUPPORTED);
      return false;
    }

    this.showLoader = true;
    this.uploadedColumnNames = this.commonService.modifyHeaders(this.uploadedColumnNames, this.requiredHeaders);
    this.uploadedData = this.commonService.modifyUploadedData(this.uploadedData, this.uploadedColumnNames);
    this.missingColumns = this.commonService.checkRequiredHeaders(this.uploadedColumnNames, this.requiredHeaders);
    this.isDataLarge = this.uploadedData.length > 2000;

    if (this.missingColumns.length > 0 || this.isDataLarge) {
      this.resetPreviewState(true);
      return;
    }

    const fileData = this.uploadedData;
    const { uniqueRecords, errorRec, duplicateRecords } = this.getValidatedRecords(fileData);

    if (uniqueRecords.length === 0) {
      this.clearSelectedFile();
      this.setColumnsForUpdateType();
      this.passdata = [];
      this.faildata = [...duplicateRecords, ...errorRec];
      this.updatePreviewTable(fileData.length);
      return;
    }

    this.getPreviewObservable(uniqueRecords).subscribe(
      data => {
        const { totalSuccessRec, totalErrorRec } = data;
        this.setColumnsForUpdateType();
        this.passdata = totalSuccessRec;
        this.faildata = [...duplicateRecords, ...totalErrorRec, ...errorRec];
        this.updatePreviewTable(fileData.length);
      },
      err => this.handlePreviewError(err)
    );
  }

  private getValidatedRecords(fileData: any[]) {
    const { successRecords, duplicateRecords } = this.bulkService.validateRecord(fileData, this.updateType, this.uniqueHeaders);
    const records = successRecords && successRecords.length > 0 ? successRecords : [];
    const uniqueRecords = records.filter((item: any) => (item.Status && item.Status.toLowerCase()) === 'success');
    const errorRec = records.filter((item: any) => (item.Status && item.Status.toLowerCase()) === 'fail');
    return { uniqueRecords, errorRec, duplicateRecords };
  }

  private getPreviewObservable(uniqueRecords: any[]) {
    return this.updateType === 'otleader'
      ? this.maintenanceService.capitalDemandBulkPreview({ uniqueRecords })
      : this.maintenanceService.capitalDemandUCMGBulkPreview({ uniqueRecords });
  }

  private setColumnsForUpdateType() {
    if (this.updateType === 'otleader') {
      this.PASS_COLUMN = this.TABLE_COLUMNS_PASS;
      this.FAIL_COLUMN = this.TABLE_COLUMNS_FAIL;
    } else {
      this.PASS_COLUMN = this.TABLE_COLUMNS_PASS_UCMG;
      this.FAIL_COLUMN = this.TABLE_COLUMNS_FAIL_UCMG;
    }
  }

  private updatePreviewTable(totalItems: number) {
    const allErrors = this.faildata.flatMap(row => row['Message']?.split(',').map(error => error.trim()) || []);
    const uniqueErrors = Array.from(new Set(allErrors));
    this.TABLE_CONFIG.FILTER_OPTIONS['Message'] = uniqueErrors.map(error => ({ key: error, value: error }));

    this.dataSourceDetails_fail = new MatTableDataSource(this.faildata);
    this.dataSourceDetails_fail.sort = this.sort;
    this.dataSourceDetails_Pass = new MatTableDataSource(this.passdata);

    this.TABLE_CONFIG['TABLE_CLASS'] = 'capital-demand-bulk-tble-container';
    this.TABLE_CONFIG.totalItems = totalItems > 0 ? totalItems : 0;
    this.resetPreviewState(false);
    this.showtable = true;
  }

  private handlePreviewError(error: any) {
    console.error(error);
    this.showLoader = false;
    this.toaster.error(
      BULK_MAINTENANCE_ERROR_MESSAGES.CAPITAL_DEMAND_BULK.GENERIC_ERROR,
      '',
      { positionClass: 'toast-top-center', timeOut: 1000 }
    );
  }

  private clearSelectedFile() {
    this.fileToUpload = null;
    if (this.fileInput?.nativeElement) {
      this.fileInput.nativeElement.value = '';
    }
  }

  private resetPreviewState(clearFile: boolean) {
    this.showLoader = false;
    this.showtable = false;
    this.showPreview = false;
    if (clearFile) {
      this.clearSelectedFile();
    }
  }

  exportAppData() {
    let name = '';
    if (this.updateType === 'otleader') {
      name = 'Capital Demand Bulk Edit - OT Leader';
    } else {
      name = 'Capital Demand Bulk Edit - UCMG';
    }
    this.exportService.exportToExcel(name, [this.faildata]);
  }

}
